import {LANGUAGE} from '@/common/utils/constants';

export const MY_PROJECTS_PAGE = {
	[LANGUAGE.en.short]: {
		myProjects: {
			title: "My Stories",
			noProjectsMessage: "You don’t have any projects in this section.",
			unpublished: "Unpublished",
			published: "Published",
			archived: "Archived",
			customer: "Customer",
			approve: "Approve",
			projects: 'Projects',
			forReview: 'For Review',
			forApproval: 'For Approval',
			cmtReview: 'CMT Review',
			saved: 'Saved',
			shared: 'Shared',
			statuses: {
				draft: "Drafts",
				waitingForApproval: "Waiting for approval",
				pendingPublishing: "Pending publishing",
				underReview: "Under review"
			},
			tooltips: {
				edit: "Edit",
				archive: "Archive",
				approveOrDeny: "Approve/Deny",
				view: "View",
				moveToDraft: "Move to draft",
				delete: 'Delete'
			},
			savedProjects: "Saved Projects",
			searchPlaceHolder: 'Search for title or client',
			howToPromote: 'How to promote <br> your project',
			promoteInfo: 'User can <span id="promoteInfo" class="promoting">promote</span> <a></a> some of their shared projects. To do that, users should qualify by completing one of the following activities:',
			promoteBySurvey: 'Fill in a <span class="survey">survey</span>.',
			promoteByValidation: 'Perform language validation of 1 project in your native language in the last 30 days.',
			promotedBySubmission: 'Has submitted at least 3 stories in the last 30 days.'
		}
	},
	[LANGUAGE.de.short]: {
		myProjects: {
			title: "Meine Geschichten",
			noProjectsMessage: "Sie haben keine projekte in diesem abschnitt.",
			unpublished: "Unveröffentlicht",
			published: "Veröffentlicht",
			archived: "Archiviert",
			customer: "Kundin",
			approve: "Genehmigen",
			projects: 'Projekte',
			forReview: 'Zur Überprüfung',
			forApproval: 'Zur Genehmigung',
			cmtReview: 'CMT-Überprüfung',
			saved: 'Gespeichert',
			shared: 'Geteilt',
			statuses: {
				draft: "Entwürfe",
				waitingForApproval: "Warten auf die bestätigung",
				pendingPublishing: "Ausstehende Veröffentlichung",
				underReview: "Wird überprüft"
			},
			tooltips: {
				edit: "Bearbeiten",
				archive: "Archiv",
				approveOrDeny: "Genehmigen/Ablehnen",
				view: "Aussicht",
				moveToDraft: "Zum Entwurf wechseln",
				delete: 'Löschen'
			},
			savedProjects: "Gespeicherte Projekte",
			searchPlaceHolder: 'Suchen Sie nach Titel oder Kunde',
			howToPromote: 'So fördern Sie <br> Ihr Projekt',
			promoteInfo: 'Nutzer können einige ihrer freigegebenen Projekte <span id="promoteInfo" class="promoting">promoten</span>. Dazu müssen sie sich durch eine der folgenden Aktivitäten qualifizieren:',
			promoteBySurvey: 'Füllen Sie eine <span class="survey">Umfrage</span> aus.',
			promoteByValidation: 'Führen Sie in den letzten 30 Tagen eine Sprachvalidierung für 1 Projekt in Ihrer Muttersprache durch.',
			promotedBySubmission: 'Hat in den letzten 30 Tagen mindestens 3 Geschichten eingereicht.'
		},
	},
	[LANGUAGE.fr.short]: {
		myProjects: {
			title: "Mes histoires",
			noProjectsMessage: "Vous n'avez aucun projet dans cette section.",
			unpublished: "Inédite",
			published: "Publié",
			archived: "Archivé",
			customer: "Cliente",
			approve: "Approuver",
			projects: 'Projets',
			forReview: 'Pour examen',
			forApproval: 'Pour approbation',
			cmtReview: 'Revue CMT',
			saved: 'Sauvé',
			shared: 'Commun',
			statuses: {
				draft: "Brouillons",
				waitingForApproval: "En attente d'approbation",
				pendingPublishing: "En attente de publication",
				underReview: "À l'étude"
			},
			tooltips: {
				edit: "Éditer",
				archive: "Archive",
				approveOrDeny: "Approuver/Refuser",
				view: "Voir",
				moveToDraft: "Passer au brouillon",
				delete: 'Effacer'
			},
			savedProjects: "Projets enregistrés",
			searchPlaceHolder: 'Rechercher un titre ou un client',
			howToPromote: 'Comment promouvoir <br> votre projet',
			promoteInfo: 'Les utilisateurs peuvent <span id="promoteInfo" class="promoting">promouvoir</span> certains de leurs projets partagés. Pour ce faire, ils doivent effectuer l\'une des activités suivantes :',
			promoteBySurvey: 'Répondez à un <span class="survey">sondage</span>.',
			promoteByValidation: 'Effectuez la validation linguistique d\'un projet dans votre langue maternelle au cours des 30 derniers jours.',
			promotedBySubmission: 'A soumis au moins 3 histoires au cours des 30 derniers jours.'
		},
	},
	[LANGUAGE.it.short]: {
		myProjects: {
			title: "Le mie storie",
			noProjectsMessage: "Non hai nessun progetto in questa sezione.",
			unpublished: "Inedita",
			published: "Pubblicato",
			archived: "Archiviato",
			customer: "Cliente",
			approve: "Approvare",
			projects: 'Progetti',
			forReview: 'Per la revisione',
			forApproval: 'Per approvazione',
			cmtReview: 'Revisione CMT',
			saved: 'Salvato',
			shared: 'Condiviso',
			statuses: {
				draft: "Bozze",
				waitingForApproval: "In attesa di approvazione",
				pendingPublishing: "In attesa di pubblicazione",
				underReview: "In corso di revisione"
			},
			tooltips: {
				edit: "Modificare",
				archive: "Archivio",
				approveOrDeny: "Approva/Nega",
				view: "Visualizzazione",
				moveToDraft: "Passa alla bozza",
				delete: 'Elimina'
			},
			savedProjects: "Progetti salvati",
			searchPlaceHolder: 'Cerca titolo o cliente',
			howToPromote: 'Come promuovere il tuo progetto',
			promoteInfo: 'L\'utente può <span id="promoteInfo" class="promoting">promuovere</span> alcuni dei propri progetti condivisi. Per farlo, gli utenti devono qualificarsi completando una delle seguenti attività:',
			promoteBySurvey: 'Compila un <span class="survey">sondaggio</span>.',
			promoteByValidation: 'Esegui la convalida della lingua di 1 progetto nella tua lingua madre negli ultimi 30 giorni.',
			promotedBySubmission: 'Ha inviato almeno 3 storie negli ultimi 30 giorni.'
		},
	},
	[LANGUAGE.ja.short]: {
		myProjects: {
			title: "私のストーリー",
			noProjectsMessage: "このセクションにはプロジェクトがありません。",
			unpublished: "未発表",
			published: "公開",
			archived: "アーカイブ",
			customer: "お客様",
			approve: "承認",
			projects: 'プロジェクト',
			forReview: 'レビュー用',
			forApproval: '承認のため',
			cmtReview: 'CMTレビュー',
			saved: '保存されました',
			shared: '共有',
			statuses: {
				draft: "ドラフト",
				waitingForApproval: "承認待ち",
				pendingPublishing: "公開待ち",
				underReview: "レビュー中"
			},
			tooltips: {
				edit: "編集",
				archive: "記録",
				approveOrDeny: "承認/拒否",
				view: "意見",
				moveToDraft: "下書きに移動",
				delete: '消去'
			},
			savedProjects: "保存されたプロジェクト",
			searchPlaceHolder: 'タイトルまたはクライアントを検索する',
			howToPromote: 'プロジェクトを宣伝する方法',
			promoteInfo: 'ユーザーは共有プロジェクトの一部を<span id="promoteInfo" class="promoting">プロモート</span>できます。プロモートするには、以下のいずれかのアクティビティを完了する必要があります',
			promoteBySurvey: '<span class="survey">アンケート</span>にご記入ください。',
			promoteByValidation: '過去 30 日間に、1 件のプロジェクトの言語検証を母国語で実行します。',
			promotedBySubmission: '過去 30 日間に少なくとも 3 つのストーリーを投稿しました。'
		},
	},
	[LANGUAGE.es.short]: {
		myProjects: {
			title: "Mis historias",
			noProjectsMessage: "No tienes ningún proyecto en esta sección.",
			unpublished: "Inédito",
			published: "Publicado",
			archived: "Archivado",
			customer: "Cliente",
			approve: "Aprobar",
			projects: 'Proyectos',
			forReview: 'Para revisión',
			forApproval: 'Para aprobación',
			cmtReview: 'Revisión CMT',
			saved: 'Guardado',
			shared: 'Compartido',
			statuses: {
				draft: "Borradores",
				waitingForApproval: "Esperando aprobación",
				pendingPublishing: "Pendiente de publicación",
				underReview: "En revisión"
			},
			tooltips: {
				edit: "Editar",
				archive: "Archivo",
				approveOrDeny: "Aprobar/Denegar",
				view: "Ver",
				moveToDraft: "Mover a borrador",
				delete: 'Eliminar'
			},
			savedProjects: "Proyectos guardados",
			searchPlaceHolder: 'Buscar por título o cliente',
			howToPromote: 'Cómo promocionar <br> tu proyecto',
			promoteInfo: 'Los usuarios pueden <span id="promoteInfo" class="promoting">promocionar</span> algunos de sus proyectos compartidos. Para ello, los usuarios deben calificar completando una de las siguientes actividades:',
			promoteBySurvey: 'Completar una <span class="survey">encuesta</span>.',
			promoteByValidation: 'Realizar la validación del idioma de 1 proyecto en su lengua materna en los últimos 30 días.',
			promotedBySubmission: 'Ha enviado al menos 3 historias en los últimos 30 días.'
		},
	}
}
